import { vaultGetRequest } from '../helpers';
import type { IFetchVaultFilesResponse } from './fetch-vault-files-response';
import { fetchVaultFilesResponseSchema } from './fetch-vault-files-response';

export async function fetchVaultFilesApi(path: string): Promise<IFetchVaultFilesResponse> {
  return vaultGetRequest({
    path: `/vault/files?path=${encodeURIComponent(path)}`,
    schema: fetchVaultFilesResponseSchema,
  });
}
